import React, { Component, useRef, useEffect } from 'react'
import Header from "../component/Header"
export default function About() {

	return (
		<div>
			<Header />
			<div className="md:w-1/2 max-w-full sm:w-auto mx-auto">
				<h1 className="text-4xl font-bold text-sky-500 md:mt-24 mt-16 ">About Us</h1>
				<p className="text-sky-600 m-5 leading-relaxed">
					We are World Trade Port, creators of the Blue Sky Index™—your connection to the multiverse.
					The BSI is a stepping stone toward a fair, BSI-based barter economy built on prosperity and peace for people and nations worldwide.
					Revenue generated through the BSI is invested in Project Generators that support fast flash barter trading, entertainment, culture, youth programs, animal welfare, and environmental initiatives.
				</p>
			</div>
		</div>
	)
}